export default () => {
  const mainNav = document.querySelectorAll('.main-nav');

  mainNav.forEach((block) => {
    const menuItems = block.querySelectorAll('.menu-item-has-children');
    const langSwitch = block.querySelector('.lang-switch');

    menuItems.forEach((item) => {
      const mainAnchor = item.children[0];
      const allAnchors = item.querySelectorAll('a');
      let focused = false;

      mainAnchor.addEventListener('click', (event) => {
        event.preventDefault();
        item.classList.toggle('expanded');
      });

      allAnchors.forEach((anchor) => {
        anchor.addEventListener('blur', (event) => {
          focused = false;
          setTimeout(() => {
            if (!focused) {
              item.classList.remove('focused');
            }
          }, 100)
        });
        anchor.addEventListener('focus', (event) => {
          focused = true;
          item.classList.add('focused');
        });
      })
    });

    if (langSwitch) {
      langSwitch.addEventListener('click', (event) => {
        event.preventDefault();
        langSwitch.classList.toggle('opened');
      });

      document.addEventListener('click', (event) => {
        if (langSwitch !== event.target && !langSwitch.contains(event.target)) {
          langSwitch.classList.remove('opened');
        }
      });

      document.body.addEventListener('menu-closed', () => {
        langSwitch.classList.remove('opened');
      });
    }
  });

  document.querySelectorAll('a').forEach((anchor) => {
    if (anchor.href === '#') {
      anchor.addEventListener('click', (event) => {
        event.preventDefault();
      });
    }
  });
};
